import React from 'react';
import PropTypes from 'prop-types';

// @source
import * as Styled from '../../styled';

const TableHead = ({ title, action }) => (
  <Styled.TableRow isTitle>
    <Styled.TableTitle>{title}</Styled.TableTitle>
    {action && <Styled.TableRowIcon>{action}</Styled.TableRowIcon>}
  </Styled.TableRow>
);

TableHead.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool,
  ]),
};

TableHead.defaultProps = {
  action: false,
};

export default TableHead;
